<template>
  <div class="etf-basic-wrapper">
    <component :is="component" :data="basicInfo" class="section-margin" />
    <FundStyle :data="market === 'hk' ? basicInfo.investTarget : basicInfo.investmentGoal" />
  </div>
</template>

<script>
import FundBasicHk from './FundBasicHk.vue'
import FundBasicUs from './FundBasicUs.vue'
import FundStyle from './FundStyle.vue'
const components = { hk: FundBasicHk, us: FundBasicUs }
export default {
  components: { FundBasicHk, FundBasicUs, FundStyle },
  data() {
    return {
      basicInfo: {}
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    component() {
      return components[this.market]
    }
  },
  created() {
    this.getBasicInfo()
  },
  methods: {
    async getBasicInfo() {
      const res = await this.$post(this.$api.f10[this.market] + '/summary/basic', {
        symbol: this.symbol
      })
      this.basicInfo = res?.data?.[0] ?? {}
    }
  }
}
</script>

<style lang="scss">
.etf-basic-wrapper {
  .col-table--etf {
    --col-table-title-width: 100px;
  }
}
</style>
